<ng-container *ngIf="context === 'article'">
<div *ngIf="(articleStoreService.currentListLengthState | async) != 0 || (articleStoreService.currentListEnabledTabState | async) != listTableTabs.ALL || (articleStoreService.currentListSearchTextState | async).length != 0 ;" mwc-row mwcJustify="space-between" [mwcGutter]="[24, 0]" class="blog-studio-performance">
  <div mwc-col [mwcSpan]="6" class="article-cards-container article-cards-container--published">
    <mwc-card [mwcBodyStyle]="{ padding:'0px' }" class="article-cards article-cards--published">
      <mwc-row>
        <mwc-col>
          <span class="featured-icon featured-icon--published"> <span mwc-icon mwcIconfont="send-01"></span></span>
        </mwc-col>
        <div>
          <mwc-col class="inlineAdd" style="margin-bottom:4px">
            <span class="mwc-color-gray-800 mwc-text-sm-medium">Published</span>
          </mwc-col>
          <mwc-col class="inlineAdd">
            <span class="stat-value stat-value--published mwc-display-sm-bold">{{publishedCount}}</span>
          </mwc-col>
        </div>
        <!-- <div  class="mwc-color-600 mwc-text-sm-medium">108</div>  -->
      </mwc-row>
      <div class="stat-footer">
        <span class="mwc-color-gray-500 mwc-text-sm-regular" i18n="@@bs-performance-review-last-7-days">Last 7 days</span>
        <span class="stat-footer__trend stat-footer__trend--{{getTrendDirection(publishedLast7)}}">{{publishedLast7}}</span>
      </div>
      <!-- <mwc-row>
          <mwc-col mwcSpan="24">
              <mwc-row mwcJustify="center">
                  <div style="height: 105px;padding: 8px 30px;position: relative;">
                      <mwc-progress [mwcPercent]="(articleStoreService.currentSEOWidgetState | async ).overallScore" mwcType="dashboard" [mwcWidth]="160" [mwcStrokeWidth]="6" [mwcGapDegree]="150" [mwcGapPosition]="'bottom'" [mwcStatus]="getStatusColor(+((articleStoreService.currentSEOWidgetState | async ).overallScore))" [mwcFormat]="statusFormat" [mwcShowInfo]="false"></mwc-progress>
                      <span class="mwc-display-xs-semibold mwc-color-gray-900 data-with-action">{{(articleStoreService.currentSEOWidgetState | async ).overallScore}}%</span>
                  </div>
              </mwc-row>
          </mwc-col>
      </mwc-row> -->
    </mwc-card>
  </div>
  <div mwc-col [mwcSpan]="6" class="article-cards-container article-cards-container--draft">
    <mwc-card [mwcBodyStyle]="{ padding:'0px' }" class="article-cards article-cards--draft">
      <div>
        <mwc-row>
          <mwc-col>
            <span class="featured-icon featured-icon--draft"> <span mwc-icon mwcIconfont="edit-04"></span></span>
          </mwc-col>
          <div>
            <mwc-col class="inlineAdd" style="margin-bottom:4px">
              <span class="mwc-color-gray-800 mwc-text-sm-medium">Drafts</span>
            </mwc-col>
            <mwc-col class="inlineAdd">
              <span class="stat-value mwc-color-gray-900 mwc-display-sm-bold">{{draftCount}}</span>
            </mwc-col>
          </div>
        </mwc-row>
        <div class="stat-footer">
          <span class="mwc-color-gray-500 mwc-text-sm-regular" i18n="@@bs-performance-review-last-7-days">Last 7 days</span>
          <span class="stat-footer__trend stat-footer__trend--{{getTrendDirection(draftLast7)}}">{{draftLast7}}</span>
        </div>

        <!-- <mwc-row class="paddTop">
            <mwc-col>
              <span class="mwc-color-gray-900 mwc-display-sm-semibold">{{(articleStoreService.currentSEOWidgetState | async ).poorCount}}</span>
            </mwc-col>
        </mwc-row> -->
        <!-- <mwc-row style="padding-bottom: -55px !important;">
            <mwc-col>
                <span i18n="@@bs-performance-review-poor-sub-text" class="mwc-color-gray-600 mwc-text-xs-regular">With low SEO score
                    &nbsp; &nbsp;</span>
            </mwc-col>
        </mwc-row> -->
      </div>
    </mwc-card>
  </div>
  <div mwc-col [mwcSpan]="6" class="article-cards-container article-cards-container--scheduled">
    <mwc-card [mwcBodyStyle]="{ padding:'0px' }" class="article-cards article-cards--scheduled">
      <mwc-row>
        <mwc-col>
          <span class="featured-icon featured-icon--scheduled"> <span mwc-icon mwcIconfont="clock"></span></span>
        </mwc-col>
        <div>
          <mwc-col class="inlineAdd" style="margin-bottom:4px">
            <span class="mwc-color-gray-800 mwc-text-sm-medium">Scheduled</span>
          </mwc-col>
          <mwc-col class="inlineAdd">
            <span class="stat-value stat-value--scheduled mwc-display-sm-bold">{{scheduledCount}}</span>
          </mwc-col>
        </div>
      </mwc-row>
      <div class="stat-footer">
        <span class="mwc-color-gray-500 mwc-text-sm-regular" i18n="@@bs-performance-review-last-7-days">Last 7 days</span>
        <span class="stat-footer__trend stat-footer__trend--{{getTrendDirection(scheduledLast7)}}">{{scheduledLast7}}</span>
      </div>

      <!-- <mwc-row class="paddTop">
          <mwc-col>
            <span class="mwc-color-gray-900 mwc-display-sm-semibold">{{(articleStoreService.currentSEOWidgetState | async ).averageCount}}</span>
          </mwc-col>
      </mwc-row> -->
      <!-- <mwc-row>
          <mwc-col>
              <span i18n="@@bs-performance-review-average-sub-text" class="mwc-color-gray-600 mwc-text-xs-regular">With avg. SEO
                  score &nbsp;</span>
          </mwc-col>
      </mwc-row> -->
    </mwc-card>
  </div>
  <div mwc-col [mwcSpan]="6" class="article-cards-container article-cards-container--score">
    <mwc-card [mwcBodyStyle]="{ padding:'0px' }" class="article-cards article-cards--score">
      <mwc-row>
        <mwc-col>
          <span class="featured-icon featured-icon--score"> <span mwc-icon mwcIconfont="seo"></span></span>
        </mwc-col>
        <div>
          <mwc-col class="inlineAdd" style="margin-bottom:4px">
            <span class="mwc-color-gray-800 mwc-text-sm-medium">Avg. Score</span>
          </mwc-col>
          <mwc-col class="inlineAdd">
            <span class="stat-value stat-value--score mwc-display-sm-bold">{{avgSeoScore}}%</span>
          </mwc-col>
        </div>
      </mwc-row>
      <div class="stat-footer">
        <span class="mwc-color-gray-500 mwc-text-sm-regular" i18n="@@bs-performance-review-last-7-days">Last 7 days</span>
        <span class="stat-footer__trend stat-footer__trend--{{getTrendDirection(avgSeoLast7)}}">{{avgSeoLast7}}%</span>
      </div>

      <!-- <mwc-row class="paddTop">
          <mwc-col>
            <span class="mwc-color-gray-900 mwc-display-sm-semibold ">{{(articleStoreService.currentSEOWidgetState | async ).goodCount}}</span>
          </mwc-col>
      </mwc-row> -->
      <!-- <mwc-row>
          <mwc-col>
              <span i18n="@@bs-performance-review-good-sub-text" class="mwc-color-gray-600 mwc-text-xs-regular">With good SEO score
                  &nbsp;</span>
          </mwc-col>
      </mwc-row> -->
    </mwc-card>
  </div>
</div>
</ng-container>

<ng-container *ngIf="context === 'campaign'">
  <div mwc-row mwcJustify="space-between" [mwcGutter]="[24, 0]" class="blog-studio-performance">
    <div mwc-col [mwcSpan]="6" class="article-cards-container article-cards-container--total">
      <mwc-card [mwcBodyStyle]="{ padding:'0px' }" class="article-cards article-cards--total">
        <mwc-row>
          <mwc-col>
            <span class="featured-icon featured-icon--total"> <span mwc-icon mwcIconfont="folder"></span></span>
          </mwc-col>
          <div>
            <mwc-col class="inlineAdd" style="margin-bottom:4px">
              <span class="mwc-color-gray-800 mwc-text-sm-medium">Total Projects</span>
            </mwc-col>
            <mwc-col class="inlineAdd">
              <span class="stat-value stat-value--total mwc-display-sm-bold">{{totalProjectsCount}}</span>
            </mwc-col>
          </div>
        </mwc-row>
        <div class="stat-footer">
          <span class="mwc-color-gray-500 mwc-text-sm-regular" i18n="@@bs-performance-review-last-7-days">Last 7 days</span>
          <span class="stat-footer__trend stat-footer__trend--{{getTrendDirection(totalProjectsLast7)}}">{{totalProjectsLast7}}</span>
        </div>
      </mwc-card>
    </div>
    <div mwc-col [mwcSpan]="6" class="article-cards-container article-cards-container--totalitems">
      <mwc-card [mwcBodyStyle]="{ padding:'0px' }" class="article-cards article-cards--totalitems">
        <mwc-row>
          <mwc-col>
            <span class="featured-icon featured-icon--totalitems"> <span mwc-icon mwcIconfont="package-minus"></span></span>
          </mwc-col>
          <div>
            <mwc-col class="inlineAdd" style="margin-bottom:4px">
              <span class="mwc-color-gray-800 mwc-text-sm-medium">Total Items</span>
            </mwc-col>
            <mwc-col class="inlineAdd">
              <span class="stat-value stat-value--totalitems mwc-display-sm-bold">{{totalItemsCount}}</span>
            </mwc-col>
          </div>
        </mwc-row>
        <div class="stat-footer">
          <span class="mwc-color-gray-500 mwc-text-sm-regular" i18n="@@bs-performance-review-last-7-days">Last 7 days</span>
          <span class="stat-footer__trend stat-footer__trend--{{getTrendDirection(totalItemsLast7)}}">{{totalItemsLast7}}</span>
        </div>
      </mwc-card>
    </div>
    <div mwc-col [mwcSpan]="6" class="article-cards-container article-cards-container--ready">
      <mwc-card [mwcBodyStyle]="{ padding:'0px' }" class="article-cards article-cards--ready">
        <mwc-row>
          <mwc-col>
            <span class="featured-icon featured-icon--ready"> <span mwc-icon mwcIconfont="check-circle"></span></span>
          </mwc-col>
          <div>
            <mwc-col class="inlineAdd" style="margin-bottom:4px">
              <span class="mwc-color-gray-800 mwc-text-sm-medium">Ready</span>
            </mwc-col>
            <mwc-col class="inlineAdd">
              <span class="stat-value stat-value--ready mwc-display-sm-bold">{{readyCount}}</span>
            </mwc-col>
          </div>
        </mwc-row>
        <div class="stat-footer">
          <span class="mwc-color-gray-500 mwc-text-sm-regular" i18n="@@bs-performance-review-last-7-days">Last 7 days</span>
          <span class="stat-footer__trend stat-footer__trend--{{getTrendDirection(readyLast7)}}">{{readyLast7}}</span>
        </div>
      </mwc-card>
    </div>
    <div mwc-col [mwcSpan]="6" class="article-cards-container article-cards-container--inprogress">
      <mwc-card [mwcBodyStyle]="{ padding:'0px' }" class="article-cards article-cards--inprogress">
        <mwc-row>
          <mwc-col>
            <span class="featured-icon featured-icon--inprogress"> <span mwc-icon mwcIconfont="refresh-cw-01"></span></span>
          </mwc-col>
          <div>
            <mwc-col class="inlineAdd" style="margin-bottom:4px">
              <span class="mwc-color-gray-800 mwc-text-sm-medium">In Progress</span>
            </mwc-col>
            <mwc-col class="inlineAdd">
              <span class="stat-value stat-value--inprogress mwc-display-sm-bold">{{inProgressCount}}</span>
            </mwc-col>
          </div>
        </mwc-row>
        <div class="stat-footer">
          <span class="mwc-color-gray-500 mwc-text-sm-regular" i18n="@@bs-performance-review-last-7-days">Last 7 days</span>
          <span class="stat-footer__trend stat-footer__trend--{{getTrendDirection(inProgressLast7)}}">{{inProgressLast7}}</span>
        </div>
      </mwc-card>
    </div>
  </div>
</ng-container>
